module.exports = __webpack_public_path__ + "static/media/text-only.0d8bd79c.svg";